import Axios from "axios";
import {
  SET_SALES_CONTACT_LIST,
  UNSET_SALES_CONTACT_LIST,
} from "@/store/mutation-types";

import { salesContactResource } from "@/store/api";

const state = {
  getSalesContactList: [],
};

const getters = {
  getSalesContactList(state) {
    return state.getSalesContactList;
  },
};

const mutations = {
  [SET_SALES_CONTACT_LIST](state, data) {
    state.getSalesContactList = data;
  },
  [UNSET_SALES_CONTACT_LIST](state) {
    state.getSalesContactList = [];
  },
};

const actions = {
  getSalesContactList({ commit }, params = {}) {
    return new Promise((resolve, reject) => {
      Axios.get(salesContactResource, { params })
        .then((response) => {
          commit(SET_SALES_CONTACT_LIST, response.data.data);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_SALES_CONTACT_LIST);
          reject(error);
        });
    });
  },

  saveSalesContact({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });

    return new Promise((resolve, reject) => {
      Axios.post(salesContactResource, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  updateSalesContact({ commit }, { id, data }) {
    commit("SET_LOADING", { color: "primary" });

    const url = `${salesContactResource}/${id}`;

    return new Promise((resolve, reject) => {
      Axios.put(url, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  getSalesContact({ commit }, id) {
    commit("SET_LOADING", { color: "primary" });

    const url = `${salesContactResource}/${id}`;

    return new Promise((resolve, reject) => {
      Axios.get(url)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

